export function getOperatingSystem() {
  return global.window.navigator.platform;
}

export function getIsMac() {
  return getOperatingSystem().indexOf('Mac') >= 0;
}
